import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
    fetchFridge,
    fetchFridges,
    fetchSensor,
    fetchSensorHistory,
    FetchSensorHistoryParams,
    fetchSensors,
} from '../queries/sensors.queries';

export const useSensors = (storeId?: number | null) => {
    return useQuery({
        queryKey: ['sensors', storeId],
        queryFn: () => fetchSensors(storeId ?? undefined),
    });
};

export const useSensor = (id: number) => {
    return useQuery({
        queryKey: ['sensor', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchSensor(id);
        },
    });
};

export const useFridges = (storeId?: number | null) => {
    return useQuery({
        queryKey: ['fridges', storeId],
        queryFn: () => fetchFridges(storeId ?? undefined),
        staleTime: 5 * 60 * 1000, // 5 minutes
        placeholderData: keepPreviousData,
    });
};

export const useFridge = (id: number) => {
    return useQuery({
        queryKey: ['fridge', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchFridge(id);
        },
    });
};

export const useSensorHistory = (params: FetchSensorHistoryParams) => {
    return useQuery({
        queryKey: [
            'sensorHistory',
            params.storeId,
            params.sensorIds,
            params.startTime,
            params.endTime,
        ],
        queryFn: () => fetchSensorHistory(params),
    });
};
